import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { white, greenLight } from 'styles/colors';

export const ProgressBarSection = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40px;
	position: fixed;
	bottom: 0;
	right: 0;
	width: 100%;
	background-color: ${props => (props.error ? colors.amber : greenLight)};
	border-radius: 1px;
	z-index: 10;
`;

export const ProgressBarTextWrapper = styled.div`
	color: ${white};
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
`;
export const IconWrapper = styled.div`
	position: absolute;
	right: 10px;
	top: 10px;
	cursor: pointer;
`;
